/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Api_Key_Replace_DescriptionInputs */



/**
* | output |
* | --- |
* | "A key is already on file. Enter a new one to replace it." |
*
* @param {Integrations_Api_Key_Replace_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_api_key_replace_description = /** @type {((inputs?: Integrations_Api_Key_Replace_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Api_Key_Replace_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Es ist bereits ein Schlüssel hinterlegt. Geben Sie einen neuen ein, um ihn zu ersetzen.")
	return /** @type {LocalizedString} */ ("A key is already on file. Enter a new one to replace it.")
});